module.exports = __webpack_public_path__ + "img/tnt_logo.d9a4d632.svg";